import React from "react";
import { ImageComponent } from "../global/imageComponent";
import { getSportIcon } from "../../constants/sportIcons";
import "./SportIcon.css";

/**
 * Renders admin-uploaded sport icon when available, otherwise the default static SVG.
 */
export default function SportIcon({
  sportName,
  iconUrl = null,
  className = "",
  alt,
  size = 24,
}) {
  const label = alt || sportName || "Sport";

  if (iconUrl) {
    return (
      <img
        src={iconUrl}
        alt={label}
        className={`sport-icon sport-icon--custom ${className}`.trim()}
        style={{
          width: size,
          height: size,
        }}
      />
    );
  }

  return (
    <ImageComponent
      staticImgSrc={getSportIcon(sportName)}
      className={`sport-icon sport-icon--default ${className}`.trim()}
      alt={label}
    />
  );
}
